var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobile?'mobile-foot-button':'foot-button',on:{"click":_vm.complaintAdd}},[_c('img',{staticClass:"button_img",attrs:{"src":require("@/assets/images/feedback_consulting.png")}}),_c('span',[_vm._v(_vm._s(_vm.lang.feedback.footButton))])])
}
var staticRenderFns = []

export { render, staticRenderFns }